export default __webpack_public_path__ + "static/media/298.71e399ea.jpg";